import $ from './jquery-global';
import { initializeJqueryPlugin } from './initialize-jquery-plugin';
import select2Source from 'select2/dist/js/select2.js?raw';

initializeJqueryPlugin({
    source: select2Source,
    isInitialized: () => typeof $.fn.select2 === 'function',
    afterInitialize: () => {
        if (typeof window.require !== 'function' && typeof $.fn.select2?.amd?.require === 'function') {
            window.require = $.fn.select2.amd.require;
        }

        if (typeof window.define !== 'function' && typeof $.fn.select2?.amd?.define === 'function') {
            window.define = $.fn.select2.amd.define;
            window.define.amd = true;
        }
    },
});

export default $;
